var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabIconChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 47.276 45.144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7349",
    "data-name": "Group 7349",
    transform: "translate(-1.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22674",
    "data-name": "Path 22674",
    d: "M36.641,1.405c-1.9-.155-4.265-.155-7.282-.155H20.416c-3.016,0-5.381,0-7.282.155A13.014,13.014,0,0,0,8.153,2.628,12.644,12.644,0,0,0,2.628,8.153a13.014,13.014,0,0,0-1.223,4.981c-.155,1.9-.155,4.265-.155,7.282v9.371a9.943,9.943,0,0,0,9.943,9.943h1.323a.772.772,0,0,1,.717,1.059,4.071,4.071,0,0,0,6.146,4.824l5.741-4.1.108-.077a9.345,9.345,0,0,1,5.323-1.706h1.662c3.405,0,5.482,0,7.227-.511a12.643,12.643,0,0,0,8.575-8.575c.512-1.745.511-3.822.511-7.227v-3c0-3.016,0-5.381-.155-7.282a13.015,13.015,0,0,0-1.223-4.981,12.643,12.643,0,0,0-5.526-5.525,13.013,13.013,0,0,0-4.981-1.223ZM9.651,5.567A9.818,9.818,0,0,1,13.4,4.693c1.751-.143,3.981-.144,7.087-.144h8.8c3.106,0,5.336,0,7.087.144a9.819,9.819,0,0,1,3.753.874,9.347,9.347,0,0,1,4.084,4.084,9.822,9.822,0,0,1,.874,3.752c.143,1.751.144,3.981.144,7.087v2.6c0,3.83-.017,5.392-.378,6.622a9.346,9.346,0,0,1-6.338,6.338c-1.23.361-2.792.378-6.622.378h-1.36a12.644,12.644,0,0,0-7.2,2.308l-5.866,4.19a.772.772,0,0,1-1.166-.915,4.071,4.071,0,0,0-3.78-5.583H11.192a6.644,6.644,0,0,1-6.644-6.644v-9.3c0-3.106,0-5.336.144-7.087a9.818,9.818,0,0,1,.874-3.752A9.345,9.345,0,0,1,9.651,5.567Z",
    transform: "translate(0 0)",
    fill: "#9797bd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22675",
    "data-name": "Path 22675",
    d: "M11.4,11.2A2.2,2.2,0,1,1,9.2,9,2.2,2.2,0,0,1,11.4,11.2Z",
    transform: "translate(6.894 9.291)",
    fill: "#9797bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22676",
    "data-name": "Path 22676",
    d: "M15.4,11.2A2.2,2.2,0,1,1,13.2,9,2.2,2.2,0,0,1,15.4,11.2Z",
    transform: "translate(11.689 9.291)",
    fill: "#9797bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22677",
    "data-name": "Path 22677",
    d: "M19.4,11.2A2.2,2.2,0,1,1,17.2,9,2.2,2.2,0,0,1,19.4,11.2Z",
    transform: "translate(16.485 9.291)",
    fill: "#9797bd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabIconChat);
export default __webpack_public_path__ + "static/media/TabIconChat.ee723047909572b18e3ed24b7e36ddea.svg";
export { ForwardRef as ReactComponent };